module.exports = __webpack_public_path__ + "img/ExitusC_logotipo.d8b2ce88.png";